import { useEffect } from "react";

export const SITE_NAME = "黑料热点";

export interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
  canonicalPath?: string;
  ogType?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

function buildOrigin(): string {
  if (typeof window === "undefined") return "https://www.heiliao-hot.com";
  const base = typeof __BASE_PATH__ === "string" ? __BASE_PATH__ : "/";
  const prefix = base.split("/").filter(Boolean).join("/");
  const path = prefix ? `/${prefix}` : "";
  return `${window.location.origin}${path}`;
}

function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function useSeo({
  title,
  description,
  keywords,
  canonicalPath = "/",
  ogType = "website",
  jsonLd,
}: SeoOptions) {
  useEffect(() => {
    const jsonLdString = jsonLd ? JSON.stringify(jsonLd) : "";
    document.title = title;
    setMeta("name", "description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("name", "robots", "index,follow");

    const origin = buildOrigin();
    const url = `${origin}${canonicalPath}`;

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", ogType);
    setMeta("property", "og:url", url);
    setMeta("property", "og:locale", "zh_CN");

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    const scriptId = "page-structured-data";
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();
    if (jsonLdString) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "application/ld+json";
      script.textContent = jsonLdString;
      document.head.appendChild(script);
    }
  }, [title, description, keywords, canonicalPath, ogType, JSON.stringify(jsonLd)]);
}